import { Stack } from '@mui/material';
import { Category, ICategory } from './Category';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Doctors, Therapy } from 'Images';
import { SUPPLIERS_ID } from 'Enum/suppliers';

export const Categories = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).lobby
    .categories;

  const categories: ICategory[] = [
    {
      image: Therapy,
      text: dictionary.therapy,
      url: '/suppliers/therapy',
      supplierId: SUPPLIERS_ID.mentalTherapy,
    },
    {
      image: Doctors,
      text: dictionary.doctors,
      url: '/suppliers/medical',
      supplierId: SUPPLIERS_ID.doctors,
    },
  ];

  return (
    <Stack
      direction='row'
      justifyContent='center'
      alignItems='center'
      columnGap='24px'
      rowGap={isDesktop ? '32px' : '16px'}
      flexWrap='wrap'
      sx={{
        m: '0 auto',
        maxWidth: '870px',
      }}
    >
      {categories.map((categoryItem: ICategory, index: number) => {
        return (
          <Category
            key={index}
            image={categoryItem.image}
            text={categoryItem.text}
            url={categoryItem.url}
            supplierId={categoryItem.supplierId}
          />
        );
      })}
    </Stack>
  );
};
